import { useConfigStore } from '~/store/useConfigStore'

export const useCustomFont = () => {
  const { info } = console
  const config = useConfigStore()
  const init = () => {
    const { websiteFont } = config.$state

    if (!websiteFont) {
      return
    }

    info(`Custom Font ${websiteFont.family} in use.`)

    useHead({
      htmlAttrs: {
        style: `--custom-font: '${websiteFont.family}';`,
      },
      link: [
        {
          rel: 'stylesheet',
          href: `https://fonts.googleapis.com/css?family=${websiteFont.family}:ital,wght@0,200..900;1,700&display=swap&subset=cyrillic,latin`,
        },
      ],
    })
  }

  init()

  return {
    init,
  }
}
